import { Box, Button, ButtonProps, CircularProgress } from "@mui/material";
import { ReactNode } from "react";
type Props = {
  children?: ReactNode;
  isLoading?: boolean;
} & ButtonProps;
export default function LoadingButton({
  children,
  isLoading = false,
  ...buttonProps
}: Props) {
  return (
    <Button {...buttonProps}>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: ".5rem",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {isLoading && <CircularProgress size={18} color="inherit" />}
        {children}
      </Box>
    </Button>
  );
}
